import { Menu, MenuItemProps } from '@televet/kibble-ui';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Tooltip } from '@televet/kibble-ui/build/components/Tooltip';
import React, { useState } from 'react';
import { AudioCallMenuProps } from './index';

const AudioCallMenu = ({
  isOverlay,
  petParentOptions,
  petParentOptionsMap,
  onStartPhoneCall,
}: AudioCallMenuProps): JSX.Element => {
  const [hideTooltip, setHideTooltip] = useState(false);

  return (
    <Tooltip isOpen={hideTooltip ? false : undefined} label="Audio Call">
      <Box>
        <Menu
          onOpen={(): void => setHideTooltip(true)}
          dataTestId="start-phone-call-button"
          placement="top"
          strategy="absolute"
          isLazy
          containerProps={{
            onClose: (): void => {
              setHideTooltip(false);
            },
          }}
          buttonProps={{
            variant: 'ghostNeutral',
            leftIconName: 'phone',
            showRightIcon: false,
            size: isOverlay ? 'sm' : 'md',
          }}
          listProps={{
            menuItems: petParentOptions,
            onSelect: (selectedItem: MenuItemProps): void => {
              const parent = petParentOptionsMap.get(selectedItem.value || '');
              if (!parent) {
                return;
              }
              onStartPhoneCall(parent);
            },
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default AudioCallMenu;
